// extracted by mini-css-extract-plugin
export default {"uploadActionBtnText":"Buttons_uploadActionBtnText__0W6+P","uploadActionBtn":"Buttons_uploadActionBtn__9DnMN"};